
import * as t from 'io-ts';
import { buildValidator } from 'src_common/common/mobx-utils/buildValidator';

const WebsocketV1ResponseSuccessIO = t.interface({
    status: t.literal('ok')
});

export const decodeResponseSuccess = buildValidator('WebsocketV1ResponseSuccessIO', WebsocketV1ResponseSuccessIO);

